// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","errorRed":"#ff2a2a","productCardLabelZIndex":"1","caption2":"_3FCgXshmQfWC83mTTDn6Lf","customWhite":"#ffffff","primaryGreen":"#028154","extraLargeMinWidth":"1500px","customBlack":"#000000","textGreen":"#009e66","caption":"_1dJD2pSCq2-UhXWE_3mRfd","borderGrey":"#d5dfdf","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","small":"_22zGKWmKy0aZd_9Ue1eYfN","strongYellow":"#fada40","strongOrange":"#ff9800","extraSmallMaxWidth":"767px","plans":"_3wMlD4J8FKBKMMCiUngKTM"};


//////////////////
// WEBPACK FOOTER
// ./src/common/plans/Plans.css
// module id = 920
// module chunks = 1